<template>
<el-collapse v-model="isOpen">
    <el-collapse-item :title="$t('common.search')" name="cases-and-clims-search-section" id="cases-and-clims-search-section">
      <el-form :inline="true" :model="filters" size="mini" class="search-section-form">
        <el-row :gutter="10">
          <!-- Case # -->
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('casesAndClaims.caseNumber')">
              <el-input v-model="filters.caseNumber" :placeholder="$t('casesAndClaims.placeholder.caseNumber')"></el-input>
            </el-form-item>
          </el-col>
          <!-- Pickup Date Range -->
          <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="10">
              <el-form-item :label="$t('casesAndClaims.pickupDate')">
                  <el-date-picker
                      v-model="filters.pickupDateRange"
                      type="daterange"
                      format="MM/dd/yyyy"
                      value-format="yyyy-MM-dd"
                      range-separator="To"
                      start-placeholder="Start date"
                      end-placeholder="End date"
                      size="mini"
                      style="width: 100%"
                      >
                  </el-date-picker>
              </el-form-item>
          </el-col>
          <!-- Status -->
          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
             <el-form-item :label="$t('casesAndClaims.status') || 'Status'">
               <!-- Aqui deberiamos usar el select de status existente o uno simplificado -->
               <el-select v-model="filters.statusClaim" placeholder="Select" style="width: 100%;">
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
           <!-- Invoice # -->
          <el-col :xs="24" :sm="12" :md="6" :lg="8" :xl="8">
            <el-form-item :label="$t('casesAndClaims.invoiceNumber')">
              <el-input v-model="filters.invoiceNumber" :placeholder="$t('casesAndClaims.placeholder.invoiceNumber')"></el-input>
            </el-form-item>
          </el-col>
           <!-- Created Date Range -->
          <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="10">
              <el-form-item :label="$t('casesAndClaims.createdDate') || 'Created Date'">
                  <el-date-picker
                      v-model="filters.createdDateRange"
                      type="daterange"
                      range-separator="To"
                      format="MM/dd/yyyy"
                      value-format="yyyy-MM-dd"
                      start-placeholder="Start date"
                      end-placeholder="End date"
                      size="mini"
                      style="width: 100%"
                      >
                  </el-date-picker>
              </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="10">
          <el-col :span="24" class="text-align-end">
                <el-button @click="handleSearch" class="button-action-default" size="mini" icon="el-icon-search">{{ $t('common.search') }}</el-button>
                <el-button @click="handleClear"  size="mini">{{ $t('common.clear') }}</el-button>

          </el-col>
        </el-row>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapState } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'ClientSearchFilter',
  data() {
    return {
      isOpen: 'cases-and-clims-search-section',
      filters: {
        caseNumber: null,
        invoiceNumber: null,
        statusClaim: null,
        pickupDateRange: [],
        createdDateRange: [],
      },
      statusOptions: constants.CASES_AND_CLAIMS.STATUS_CLAIM || []
    };
  },
  computed: {
    ...mapState('clientCasesAndClaims', ['actualFilters']),
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    handleSearch() {
      // Transform range arrays to from/to fields if necessary before dispatching
      const payload = {
        ...this.filters,
        // pickupDateFrom: this.filters.pickupDateRange && this.filters.pickupDateRange.length ? this.filters.pickupDateRange[0] : null,
        // pickupDateTo: this.filters.pickupDateRange && this.filters.pickupDateRange.length ? this.filters.pickupDateRange[1] : null,
        pickupDateFrom: this.filters.pickupDateRange?.length ? this.filters.pickupDateRange[0] : null,
        pickupDateTo: this.filters.pickupDateRange?.length ? this.filters.pickupDateRange[1] : null,
        // createdDateFrom: this.filters.createdDateRange?.length ? this.formatDate(this.filters.createdDateRange[0]) : null,
        // createdDateTo: this.filters.createdDateRange?.length ? this.formatDate(this.filters.createdDateRange[1]) : null,
        dateOpenedFrom: this.filters.createdDateRange && this.filters.createdDateRange.length ? this.filters.createdDateRange[0] : null,
        dateOpenedTo: this.filters.createdDateRange && this.filters.createdDateRange.length ? this.filters.createdDateRange[1] : null,
        // For LocalDateTime (Created): Send the full ISO string
        // createdDateFrom: this.filters.createdDateRange?.length
        //   ? this.filters.createdDateRange[0].toISOString() : null,

        // createdDateTo: this.filters.createdDateRange?.length
        //   ? this.filters.createdDateRange[1].toISOString() : null,
      };
      delete payload.pickupDateRange;
      delete payload.createdDateRange;

      // Dispatch action
      this.$store.dispatch('clientCasesAndClaims/searchList', payload);
      /* .catch(err => {
        console.warn('Search failed:', err);
      }); */
    },
    handleClear() {
      this.filters = {
        caseNumber: null,
        invoiceNumber: null,
        statusClaim: null,
        pickupDateRange: [],
        createdDateRange: [],
      };
      this.handleSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
